import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { RKPayRibbon } from '@components/common';

class ActionsFormatter extends Component {
	constructor(props) {
		super(props);

		const { expanded } = props;

		this.state = {
			expanded,
		};
	}

	static getDerivedStateFromProps({ expanded }, lastState) {
		if (expanded !== lastState.expanded) return { expanded };

		return null;
	}

	shouldComponentUpdate = ({ row, allowAssign }, { expanded }) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(row.ApplicantsNeeded, lastProps.row.ApplicantsNeeded)
			|| !isEqual(row.Id, lastProps.row.Id)
			|| !isEqual(row.IsRKPay, lastProps.row.IsRKPay)
			|| !isEqual(allowAssign, lastProps.allowAssign)
			|| !isEqual(expanded, lastState.expanded)
		);
	}

	render() {
		const {
			row: {
				ApplicantsNeeded,
				IsRKPay,
			},
			onClickDetails,
			onToggleDetailsRow,
		} = this.props;

		const { expanded } = this.state;

		return (
			<Fragment>
				<Choose>
					<When condition={ApplicantsNeeded === 1}>
						<Button
							data-prevent-navigation
							onClick={onClickDetails}
							className="btn btn-primary"
						>
							View Details
						</Button>
					</When>
					<Otherwise>
						<Button
							data-prevent-navigation
							onClick={onToggleDetailsRow}
							className="transition-none color-black"
						>
							<i
								className={classNames('rkf margin-right-5 pointer-events-none', {
									'rkf-minus-o' : expanded,
									'rkf-plus-o'  : !expanded,
								})}
							/>
							Positions
						</Button>
					</Otherwise>
				</Choose>
				<If condition={IsRKPay}>
					<RKPayRibbon />
				</If>
			</Fragment>
		);
	}
}

ActionsFormatter.propTypes = {
	allowAssign        : PropTypes.bool,
	expanded           : PropTypes.bool,
	onClickDetails     : PropTypes.func,
	onToggleDetailsRow : PropTypes.func,
	row                : PropTypes.object.isRequired,
};

ActionsFormatter.defaultProps = {
	allowAssign        : false,
	expanded           : false,
	onClickDetails     : () => undefined,
	onToggleDetailsRow : () => undefined,
};

export default ActionsFormatter;
